import React, { useState } from 'react';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './styles.css';

const LoginForm = ({ onSubmit, isLoading, alert, onAlertClose }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email || !password) {
            setError('Both email and password are required');
            return;
        }
        setError('');
        onSubmit({ email, password });
    };

    return (
        <Card className="login-card shadow-sm">
            <Card.Header>
                <h5 className="app-name">FitOps</h5>
            </Card.Header>
            <Card.Body>
                {error && (
                    <Alert variant="danger" dismissible onClose={() => setError('')}>
                        {error}
                    </Alert>
                )}
                {alert && alert.show && (
                    <Alert variant={alert.variant} dismissible onClose={onAlertClose}>
                        {alert.message}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="you@example.com"
                            autoComplete="email"
                            required
                        />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="current-password"
                            required
                        />
                    </Form.Group>
                    <Button type="submit" className="w-100 login-submit-btn" disabled={isLoading}>
                        {isLoading ? 'Logging in…' : 'Log In'}
                    </Button>
                </Form>
            </Card.Body>
            <Card.Footer>
                <Link to="/forgot-password">Forgot password?</Link>
                <span className="divider">·</span>
                <span>No account? <Link to="/signup">Sign up</Link></span>
            </Card.Footer>
        </Card>
    );
};

export default LoginForm;
